export class TicketManagementModel{
    Code:number;
    OutletCode:string;
    OutletName:string;
    Address:string;
    City:string;
    State:string;
    OutletId:number;
    MerchantId:number;
    CityId:number;
    StateId:number;
    TerminalCode:number;
    OutletAddress:string;
    SerialNo:string;
    IssuerId:number;
    MerchantCode:number;
    TicketTypeId:number;
    status:number
    Description:string;
    IssueType:number
    RaisedMobile:string;
    CustomerName:string;
    TID:number;
    TerminalNumber:string;
    LastSettlementDate:string;
    LastTxnDate:string;
    TerminalId:number;
    Count:number;
    FileName:string;
    IsMerchantWise:boolean;
    IsOutletWise:boolean;
    IsTerminalWise:boolean;
    Id:number;
    TMOCode:number;
    Name:string;
}

export class IssueType{
    Name:string;
    ValueTypeId:number;
}


// WEBPACK FOOTER //
// ./src/app/models/ticketManagement/TicketManagementModel.ts